import { SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "../common/appApiCallHook";

export function useCandidatesApi() {
  const callApi = useApiCall();

  const getJobseekers = (params = {}, onSuccess: Function, onError: Function) => {
    const payload = {
      params,
    };
    callApi(SAGA_ACTIONS.CANDIDATES.GET_JOBSEEKERS, payload, onSuccess, onError, true);
  };

  const getJobseekersAdvanced = (params = {}, onSuccess: Function, onError: Function) => {
    const payload = {
      params,
    };
    callApi(SAGA_ACTIONS.CANDIDATES.GET_JOBSEEKERS_ADVANCED, payload, onSuccess, onError, true);
  };

  return {
    callGetJobseekers: getJobseekers,
    callGetJobseekersAdvanced: getJobseekersAdvanced,
  };
}
